import { Component } from '@angular/core';
import { PlayroomService } from '../../services/playroom.service';
@Component({
  selector: 'app-select-room-page',
  templateUrl: './select-room.page.html',
  styleUrls: ['./select-room.page.scss'],
})

export class SelectRoomPage {

  playrooms$ = this.roomService.playrooms$;

  constructor(private roomService: PlayroomService) {}

  ngOnInit() {
    this.roomService.getAllPlayrooms();
  }

  roomSelected(e) {
    sessionStorage.selectedRoom = e.detail.value;
  }

}